import React, { memo } from 'react';
import messages from './Messages';
import Icon from 'components/Icon';

interface IComponentProps {
  mergeSumAndCount: boolean;
}

const GridFieldsEditor: React.FC<IComponentProps> = ({ mergeSumAndCount }) => {
  return (
    <p className="col s12">
      <Icon
        type={mergeSumAndCount ? 'check-square' : 'square'}
        className="right"
      />
      {messages.mergeSumAndCount}
    </p>
  );
};

export default memo(GridFieldsEditor);
